export default {"src":"/_next/static/media/ubidots.9c92119d.gif","height":314,"width":600,"blurWidth":0,"blurHeight":0};